declare global {
  interface Window {
    _paq?: [string, ...any[]][];
    _mtm?: any[];
  }
}

export interface MatomoOptions {
  isDisabled?: boolean;
  url?: string;
  siteId?: string;
}

export default {
  install(app, { isDisabled = false, url, siteId }: MatomoOptions = {}) {
    const MATOMO_URL =
      url || process.env.VUE_APP_MATOMO_URL || 'https://rapiddata.matomo.cloud/matomo.php';
    const MATOMO_SITE_ID = siteId || process.env.VUE_APP_MATOMO_SITE_ID || '3';

    // Always define $matomo (prevents runtime errors)
    app.config.globalProperties.$matomo = {
      trackEvent(category: string, action: string, name?: string, value?: number) {
        if (isDisabled || typeof window === 'undefined' || !window._paq) return;
        window._paq.push(['trackEvent', category, action, name, value]);
      },
      trackGoal(goalId: number, revenue?: number) {
        if (isDisabled || typeof window === 'undefined' || !window._paq) return;
        window._paq.push(['trackGoal', goalId, revenue]);
      },
      trackPageView(title?: string) {
        if (isDisabled || typeof window === 'undefined' || !window._paq) return;
        if (title) window._paq.push(['setDocumentTitle', title]);
        window._paq.push(['trackPageView']);
      },
    };

    // Initialize Matomo only when enabled (production only)
    if (isDisabled || typeof window === 'undefined') return;

    window._paq = window._paq || [];
    window._mtm = window._mtm || [];

    window._mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
    window._paq.push(['enableLinkTracking']);
    window._paq.push(['alwaysUseSendBeacon']);
    window._paq.push(['enableHeartBeatTimer', 15]);
    window._paq.push(['setTrackerUrl', MATOMO_URL]);
    window._paq.push(['setSiteId', MATOMO_SITE_ID]);
    window._paq.push(['trackPageView']);

    // Load Matomo script dynamically
    const scriptUrl = MATOMO_URL.replace('matomo.php', 'matomo.js');
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptUrl;
      document.head.appendChild(script);
    }
  },
};
